import React from 'react';
import Cleave from 'cleave.js/react';

import classes from './PassportDetails.scss';

import InputMaterial from '../UI/InputMaterial/InputMaterial';
import InputLabel from '../UI/InputLabel/InputLabel';
import SearchSelectMenu from '../UI/SearchSelectMenu/SearchSelectMenu';
import mobileMapping from '../../assets/json/mobileMapping';

const passportDetails = (props) => {
    return (
        <div className="u-flex">
            <div className={`u-flex align-items-center mr-4`}>
                <InputMaterial 
                    type='text'
                    label='Nationality' 
                    alignment='left'
                    onChange={props.inputHandler} 
                    value={props.nationality} 
                    name='nationality'/>
            </div>
            <div className={`u-flex align-items-center mr-4`}>
                <InputMaterial 
                    type='text'
                    label='Passport No.' 
                    alignment='left' 
                    onChange={props.inputHandler} 
                    value={props.number}
                    name='number'/>
            </div>
            <div className={`u-flex align-items-center mr-4 u-relative u-height60`} style={{flex: '0 0 10rem'}}>
                <SearchSelectMenu 
                    value={props.selectedOption}
                    options={mobileMapping} 
                    onChange={props.onHandleChange} 
                    placeholder='Issuing Country' />
            </div>
            <div className={`${classes.FormLarge} u-flex align-items-center u-relative`}>
                <div className={`u-relative u-width100Percent`}>
                    <Cleave
                        className={classes.CustomInput}
                        options={{date: true, delimiter: '/', datePattern: ['d', 'm', 'Y']}}
                        onChange={props.onDateChangeHandler}
                        value={props.passportExpiryDateRawValue}
                        placeholder={'MM/DD/YYYY'}
                        />
                    <span className={classes.Bar}></span>
                    <InputLabel isActive={true}>Passport Expiry</InputLabel>
                </div>
            </div>
        </div>
    )
}

export default passportDetails;


// WEBPACK FOOTER //
// ./src/components/PassportDetails/PassportDetails.js